import {useState} from "react";
import {useDispatch} from "react-redux";
import {Link} from "react-router-dom";
import {Button, Drawer} from "antd";
import {MenuOutlined} from "@ant-design/icons";

import NavbarMenu from "./NavbarMenu";

import {logout} from "../../redux/auth/auth-operations";

import {ReactComponent as Logo} from "./logo.svg";

import styles from "./menu.module.scss";

const Navbar = ()=> {
    const dispatch = useDispatch();
    const [mobileOpen, setMobileOpen] = useState(false);

    const onLogout = () => {
        dispatch(logout());
    }

    return (
        <nav className={styles.wrapper}>
            <Button className={styles.menuButton} aria-label="Open navigation" icon={<MenuOutlined />}
                    onClick={() => setMobileOpen(true)} />
            <Link to="/" className={styles.logo}>
                <Logo />
            </Link>
            <div className={styles.desktopMenu}><NavbarMenu /></div>
            <Button onClick={onLogout} className={`${styles.logoutButton} ${styles.desktopLogout}`}>Logout</Button>
            <Drawer title="ERP navigation" placement="left" width={280} open={mobileOpen}
                    onClose={() => setMobileOpen(false)} className={styles.mobileDrawer}>
                <NavbarMenu mobile onNavigate={() => setMobileOpen(false)} />
                <Button onClick={onLogout} className={styles.drawerLogout}>Logout</Button>
            </Drawer>
        </nav>
    )
}

export default Navbar;
